import React from 'react';
import s from './LoadingSpinner.module.css';

const LoadingSpinner = () => (
  <div className={s.bubble}>
    <div className={s.dots} aria-label="Loading" role="status">
      <div className={s.dot} data-testid="loading-dot" />
      <div className={s.dot} data-testid="loading-dot" style={{ animationDelay: '0.2s' }} />
      <div className={s.dot} data-testid="loading-dot" style={{ animationDelay: '0.4s' }} />
    </div>
  </div>
);

export default LoadingSpinner;
